export const QB_VISIBLITY_EXTERNAL = 'External';
export const QB_AUDIENCE_GLOBAL = 'Global';
export const QB_AUDIENCE_LOCAL = 'Local';
